import React, { createContext, useContext, useState, useCallback } from 'react';

const PrivacyContext = createContext();

export const usePrivacy = () => useContext(PrivacyContext);

const MASK = '••••••';

export const PrivacyProvider = ({ children }) => {
  const [privacyMode, setPrivacyMode] = useState(() => {
    return localStorage.getItem('privacy_mode') === 'true';
  });

  const togglePrivacy = useCallback(() => {
    setPrivacyMode(prev => {
      const next = !prev;
      localStorage.setItem('privacy_mode', String(next));
      return next;
    });
  }, []);

  const maskValue = useCallback((value) => {
    if (!privacyMode) return value;
    return MASK;
  }, [privacyMode]);

  const maskCurrency = useCallback((value) => {
    if (!privacyMode) {
      if (typeof value === 'number') return `₹${value.toLocaleString()}`;
      return value;
    }
    return `₹${MASK}`;
  }, [privacyMode]);

  return (
    <PrivacyContext.Provider value={{ privacyMode, togglePrivacy, maskValue, maskCurrency }}>
      {children}
    </PrivacyContext.Provider>
  );
};
